import { getCountryByAbbreviation, getCountry } from "country-currency-map";


export const resolveCNYLinkRoute = (link, MERCHANT_USD, enableChinaPayoutV2 = false) => {
  if (link.route) return link.route;

  if (!MERCHANT_USD && link.key === "china-payout") {
    return "/dashboard/guide/china-payout";
  }

  if (link.key === "china-payout" && enableChinaPayoutV2) {
    return "/wallets/cny/payout/v2";
  }

  return "/wallets/cny/payout";
};


export const capitalizeCurrencyCode = (currency: string) => {
  return currency?.toUpperCase();
};

export const enhancedGetCountryByAbbreviation = (abbrevition: string) => {
  if (abbrevition === "GB") {
    return "United Kingdom";
  }
  return getCountryByAbbreviation(abbrevition);
};

export const standardizeBankCode = (value) => {
  if (typeof value !== "string") return undefined;

  const positionOfUnderscore = value.indexOf("_");
  if (positionOfUnderscore === -1) return value;

  return value.substring(0, positionOfUnderscore);
};